import { MdEmail } from "react-icons/md";
import { FaPhone, FaUser } from "react-icons/fa";
import { formatDate } from "helpers/utils";
import React from 'react';
import PropTypes from 'prop-types';

const ContactItem = ({contact}) => {
  return (
    <div className='tw-p-2 sm:tw-p-3 tw-border tw-border-solid tw-border-slate-200 tw-rounded-md tw-bg-slate-50'>
      <div className="tw-flex tw-gap-2">
        <div className="tw-flex-shrink-0">
          <FaUser size="25" className="tw-text-blue-600" />
        </div>
        <div className="tw-flex-1">
          <div className="tw-flex tw-justify-between tw-mb-3">
            <h5 className="tw-mb-1 tw-text-blue-600 tw-font-semibold">{contact?.name}</h5>
            <small>{formatDate(contact?.created_date)}</small>
          </div>
          <div className="tw-mb-1">
            <div className="tw-mb-2"><MdEmail /> Email: <a href={`mailto:thv@pebsteel.com.vn`}> {contact?.email}</a></div>
            <div className="tw-mb-2"><FaPhone /> Phone: <a href={`tel:+84 977 073 155`}>{contact?.mobile}</a></div>
          </div>
          {/* <div className="tw-text-right"><FaEdit className="tw-text-blue-600 tw-cursor-pointer" title="Edit Contact" /> | <FaTrashAlt className="tw-text-red-600 tw-cursor-pointer" title="Delete Contact" /></div> */}
        </div>
      </div>
    </div>
  )
};

ContactItem.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string,
    created_date: PropTypes.string,
    email: PropTypes.string,
    mobile: PropTypes.string
  })
}

export default ContactItem;
